import { useState } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, TablePagination } from "@mui/material";

const OrderTable = ({ info }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleChange = (e) => {
    console.log(e);
  };

  return (
    <TableContainer component={Paper} elevation={1}>
      <Table sx={{ minWidth: 1000 }} aria-label='simple table'>
        <TableHead>
          <TableRow>
            <TableCell>Order Number</TableCell>
            <TableCell align='center'>Purchase Date</TableCell>
            <TableCell align='center'>Total Purchased</TableCell>
            <TableCell align='center'>Total Amount</TableCell>
            <TableCell align='center'>Status</TableCell>
            <TableCell align='center'>Transaction ID</TableCell>
            <TableCell align='center'>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {info.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
            <TableRow key={row.order_id} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
              <TableCell component='th' scope='row'>
                {row.order_id}
              </TableCell>
              <TableCell align='center'>{row.purchase_date}</TableCell>
              <TableCell align='center'>{row.datasets}</TableCell>
              <TableCell align='center'>{row.total_amount}</TableCell>
              <TableCell align='center'>{row.status}</TableCell>
              <TableCell align='center'>{row.transaction_id}</TableCell>
              <TableCell align='center'>
                <Button variant='outlined'>Make Payment</Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25, 100]}
        component='div'
        count={info.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        onClick={handleChange}
      />
    </TableContainer>
  );
};

export default OrderTable;
